import { createSlice } from '@reduxjs/toolkit'

export const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        title: "",  // current  title state management
        isOpen: false,   // modal state management for opening closing
        content: "",   // modal content management
        size: "",   // modal content management
        extraObject: {},
    },
    reducers: {

        openModal: (state, action) => {
            const { title, content, extraObject, size } = action.payload
            state.isOpen = true
            state.content = content
            state.title = title
            state.size = size || 'md'
            state.extraObject = extraObject
        },

        closeModal: (state, action) => {
            state.isOpen = false
            state.content = ""
            state.title = ""
            state.extraObject = {}
        },

    }
})

export const { openModal, closeModal } = modalSlice.actions

export default modalSlice.reducer